import React from "react";

export default function Logo({ size = 18, className = "" }) {
  return (
    <span
      className={`horizon-fractal-logo ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    />
  );
}

export function Wordmark({ size = 18, sub, className = "" }) {
  return (
    <span className={`flex items-center gap-2 font-display font-bold tracking-tight shrink-0 ${className}`}>
      <Logo size={size} />
      <span className="text-text1">HORIZON</span>
      {sub && <span className="text-text2 hidden sm:inline">{sub}</span>}
    </span>
  );
}
